/**
 * defa.views.UserLanguageForm
 * A form for changing the user's language.
 * @version 1.2.4
 */
import { defa } from 'defa-object';
import Form     from 'scripts/poppet/form';
import template from 'templates/userLanguageForm.jst.html';

const selectors = {
	inputLanguage: '[data-input=panel-language]',
};

const UserLanguageForm = Form.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	template        : template,
	noInitValidation: true,
	
	ui: {
		language: selectors.inputLanguage,
	},
	
	
	// ------------------------------------------------
	// Event handlers
	// ------------------------------------------------
	
	onRender: function () {
		this.createCountryHTML();
	},
	
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Create a list of countries as HTML-options.
	 * @void
	 */
	createCountryHTML: function () {
		
		let self      = this,
			html5     = '',
			select    = self.ui.language,
			countries = defa.vars.languages;
		
		_.each( countries, function ( country ) {
			let selected = ( self.model.get( 'language' ) === country.languageCode )
						   ? ' selected'
						   : '';
			
			let str = '<option value="%s1"%s2>%s3</option>'
				.replace( '%s1', country.languageCode )
				.replace( '%s2', selected )
				.replace( '%s3', country.languageName );
			
			html5 += str;
		} );
		
		select.append( html5 );
	},
	
	/**
	 * Execute the changes
	 * @void
	 */
	submit: function () {
		this.model.saveLanguage( {
			language: this.ui.language.val().trim(),
		} );
	},
	
} );

export default UserLanguageForm;